import axios, { AxiosHeaders } from 'axios';
import { getIdentity } from './IdentityService';

const apiUrl = process.env.REACT_APP_API_HOST;

class ApiService {
    async authHeaders(file?: boolean) {
        const headers = new AxiosHeaders({
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': "*",
            'Access-Control-Allow-Methods': 'GET, POST, PUT, DELETE',
            'Access-Control-Allow-Headers': 'Content-Type'
        });

        if (file) {
            delete headers['Content-Type'];
        }

        const identity = await getIdentity();
        if (identity.token) {
            headers['Authorization'] = "Bearer " + identity.token;
        }

        return headers;
    };

    corsHeaders = new AxiosHeaders({
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': "*",
        'Access-Control-Allow-Methods': 'GET, POST, PUT, DELETE',
        'Access-Control-Allow-Headers': 'Content-Type'
    });

    public async get(requestUrl: string, useAuth: boolean = false) {
        let headers = (useAuth) ? await this.authHeaders() : this.corsHeaders;
        let response = await axios.get(apiUrl + requestUrl, { headers });
        return response.data;
    }

    public async post(requestUrl: string, data?: any, file?: boolean) {
        let headers = await this.authHeaders(file);
        let response = await axios.post(apiUrl + requestUrl, (file) ? data : JSON.stringify(data), { headers });
        return response.data;
    }
}

const instance = new ApiService();
export default instance;